<template>
  <div class="news-page">
    <div class="big-title">
      <span>NEWS</span>
    </div>
    <ul class="news-list">
      <li v-for="(item,index) in newsList" :key="index">
        <div class="left">
          <img v-lazy="require('@/assets/images/'+item.coverImg)" alt="" class="cover">
        </div>
        <div class="right">
          <div class="right-top">
            <div class="title">{{ item.title }}</div>
            <div class="time">{{ item.time }}</div>
          </div>
          <div class="introduce" v-html="item.introduce">
          </div>
          <a target="_blank" :href="item.btnUrl" class="btn-box" v-if="item.isShowBtn">
            <img src="@/assets/images/pc/btn_gf.png" alt="">
          </a>
        </div>
      </li>
    </ul>
    <div class="readMoreBtn" v-if="!isShowMore" @click="showMore()">
      <img src="@/assets/images/pc/btn_readmore.png" alt="">
    </div>
  </div>
</template>

<script lang="ts">
import {ref, reactive} from "vue";


export default {
  name: "CCNews",
  components: {
  },
  setup() {
    let isShowMore = ref(false)
    let newsList = reactive([
      {
        id: 1,
        coverImg: 'pc/new4.jpg',
        title: 'Original Game Announcement',
        time: '2024/6/7',
        isShowBtn: false,
        btnUrl: '',
        introduce: "\"Safari Witness\", a Polaroid-like engaging theme board game on its coming release. We will roll out at the ORIGINS GAME FAIR 2024, Booth 625 in JUNE 20-23 | Columbus OH. At Fair, we also have exciting events such as Lucky Draw and Live Quick Quiz prepared for you! Don't miss out! "
      },
      {
        id: 2,
        coverImg: 'pc/news2.png',
        title: 'Win or Die Updates!',
        time: '2024/6/5',
        isShowBtn: true,
        btnUrl: 'https://gamefound.com/en/projects/whales-entertainment/win-or-die',
        introduce: 'Newest updates on Gamefound! We want to share more information about WOD to all followers and players!'
      },
      {
        id: 3,
        coverImg: 'pc/news1.png',
        title: 'New Games Announcement',
        time: '2024/2/10',
        isShowBtn: false,
        introduce: '2 new games are coming out! "Journey to the West", a thrilling adventure game inspired by the classic Chinese novel. And "Tailor Master", a unique strategy game that puts you in the shoes of a master tailor. Don\'t miss out! We will roll out the prototypes at the GAMA Expo 2024 on March 3rd to 7th.'
      },
      {
        id: 4,
        coverImg: 'pc/news3.png',
        title: '"Win or Die" Has Launched on Gamefound!',
        time: '2024/01/11',
        isShowBtn: true,
        btnUrl: 'https://gamefound.com/en/projects/whales-entertainment/win-or-die?ref=search',
        introduce: ' If you like the game, please back us and let us make the game come ture and better. Thank you!'
      },


    ])
    let moreNewsList =  {
      id: 5,
      coverImg: 'pc/news4.png',
      title: 'Win or Die Will Launch on Gamefound Soon!',
      time: '2024/1/10',
      isShowBtn: true,
      btnUrl: 'https://gamefound.com/en/projects/whales-entertainment/win-or-die?ref=search',
      introduce: 'Now it is preview phase, please "Follow" us on Gamefound. We will post WoD updates and relevant content on it. Any questions about WoD or crowdfunding,you can also leave comment on the page. We will get back to you ASAP.'
    };
    const showMore = () => {
      isShowMore.value = !isShowMore.value
      if(isShowMore.value) {
        newsList.push(moreNewsList)
      }else {
        newsList.splice(newsList.length-1, 1)
      }
    }
    return {
      newsList,
      isShowMore,
      showMore
    }
  }
}
</script>

<style scoped lang="less">
.news-page {
  width: 100%;
  background: #f1f1f1;
  .big-title {
    color: #000;
    span {
      padding: 0 40px;
      font-size: 36px;
      position: relative;
      line-height: 90px;
      height: 90px;
      display: inline-block;
      font-family: "Aleo Regular";
      &::after{
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 12px;
        background: #30affd;
        border-radius: 2px;

      }
    }

  }
  .news-list {
    max-width: 75%;
    margin: 60px auto 0;
    padding-bottom: 40px;
    li {
      display: flex;
      justify-content: space-between;
      font-size: 18px;
      color: #2b2b2b;
      margin-top: 50px;

      .left {
        width: 50%;
        img {

          width: 90%;
          border-radius: 15px;
        }
      }
      .right {
        width: 50%;
        padding: 10px 0;
        .right-top {
          font-size: 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .introduce {
          line-height: 30px;
          color: #707070;
          text-align: left;
          margin-top: 15px;
          height: 150px;
        }
        .btn-box {
          display: flex;
          justify-content: flex-end;
          margin-top: 30px;
          img {
            width: 240px;
          }
        }
      }
      &:nth-child(2n+2) {
        flex-direction: row-reverse;
        .left {
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
  .readMoreBtn {
    border-top: 2px solid #eaeaea;
    padding: 30px 0;
    cursor: pointer;
    img {
      width: 260px;
      margin: auto;
    }
  }
}

</style>